// @ts-check
import axios from 'axios';
import config from '../constants/config';

const locationsAxios = axios.create();
const locationsService = {};

/**
 * Get list of locations for this user
 * @param {import('../../../types/common').PaginationOptions} params
 * @returns
 */
locationsService.getLocations = (params) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/locations/`;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return locationsAxios.get(url, { headers, params });
};

/**
 * Update location status
 * @param {import('../../../types/common').ObjectIdType} locationId
 * @param {boolean} newStatus
 * @returns
 */
locationsService.updateLocationStatus = (locationId, newStatus) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/locations/${locationId}/status`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const data = {
    status: newStatus,
  };

  return locationsAxios.patch(url, data, { headers });
};

/**
 * @param {import('../../../types/common').ObjectIdType} locationId
 * @returns {string} Outputs the URL for the location image endpoint
 */
locationsService.getLocationImageByIdUrl = (locationId) => {
  return `${config.BASEURL}v2/locations/${locationId}/image`;
};

export default locationsService;
